module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/unlink-3f27ead5fa410808a4f09f394448da16.svg";